/* Shopify is the sole consent authority. Optional storage fails closed. */
(() => {
  const keys = {
    local: ['storm-vitals-favorites', 'storm-ai-invite-seen-v1'],
    session: ['storm-viewed-products-v1', 'storm-picks-collapsed-mobile', 'storm-picks-collapsed-desktop', 'storm-browse-seconds']
  };
  const allowed = category => {
    const api = window.Shopify?.customerPrivacy;
    const method = {preferences:'preferencesProcessingAllowed', analytics:'analyticsProcessingAllowed', marketing:'marketingAllowed'}[category];
    return !!(api && api.currentVisitorConsent()[category] === 'yes' && api[method]?.());
  };
  const storage = kind => ({
    getItem(key) { try { return allowed('preferences') ? window[kind + 'Storage'].getItem(key) : null; } catch { return null; } },
    setItem(key, value) { try { if (allowed('preferences')) window[kind + 'Storage'].setItem(key, value); } catch {} },
    removeItem(key) { try { window[kind + 'Storage'].removeItem(key); } catch {} }
  });
  function sync() {
    if (!allowed('preferences')) for (const [kind, names] of Object.entries(keys)) {
      for (const key of names) storage(kind).removeItem(key);
    }
    document.dispatchEvent(new CustomEvent('storm:privacy', {detail:{preferences:allowed('preferences')}}));
  }
  window.StormPrivacy = {allowed, storage};
  document.addEventListener('visitorConsentCollected', sync);
  let attempts = 0;
  function load() {
    if (window.Shopify?.customerPrivacy) return sync();
    if (window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], error => {
        if (!error) sync();
        else if (++attempts < 10) setTimeout(load, 1000);
      });
    } else if (++attempts < 20) setTimeout(load, 250);
  }
  document.addEventListener('DOMContentLoaded', load, {once:true});
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-storm-cookie-preferences]');
    if (!link || !window.privacyBanner?.showPreferences) return;
    event.preventDefault();
    try { await window.privacyBanner.showPreferences(); } catch { location.href = link.href; }
  });
})();
